<div class="main-panel">
  <mode-capra-search-input
    class="search-input"
    data-test="filter-search-input"
    placeholder="Search..."
    [text]="searchTerm$ | async"
    (textChange)="onSearchTermChanged($event)"
  >
  </mode-capra-search-input>
  <div class="filter-placeholder filter-placeholder-list" *ngIf="isLoading">
    <div *ngFor="let n of visibleFilterValues$ | async | slice: 0:9" class="list-item-placeholder"></div>
    <div *ngIf="showAll" class="list-item-placeholder"></div>
  </div>
  <div cdkVirtualScrollingElement [style.height]="minimumContainerHeight">
    <span *ngIf="showAll" class="option-wrapper select-all-wrapper">
      <capra-icon
        *ngIf="!hasPartialSelection"
        icon="icon-check"
        class="option-icon"
        [class.selected]="isAll"
      ></capra-icon>
      <capra-icon *ngIf="hasPartialSelection" icon="icon-granularity-back" class="option-icon selected"></capra-icon>
      <input
        #selectAllInput
        id="filter-select-all-{{ uniqueId }}"
        name="Select All"
        type="checkbox"
        value="Select All"
        [checked]="isAll"
        [disabled]="filteredValueList.length === 0"
        [class.partially-selected]="hasPartialSelection"
        (click)="onSelectAll()"
      />
      <label class="inline-icon select-all-label" for="filter-select-all-{{ uniqueId }}">
        <span>(Select All)</span>
      </label>
    </span>

    <cdk-virtual-scroll-viewport
      [itemSize]="itemHeight"
      minBufferPx="240"
      maxBufferPx="480"
      *ngIf="!isLoading"
      class="example-viewport value-list"
    >
      <ng-container *cdkVirtualFor="let value of visibleFilterValues$ | async; index as i; trackBy: trackByValue">
        <span class="option-wrapper">
          <capra-icon [class.selected]="value.selected" icon="icon-check" class="option-icon"></capra-icon>
          <input
            id="filter-{{ i }}-{{ uniqueId }}"
            name="{{ value.value }}"
            type="checkbox"
            value="{{ value.value }}"
            [(ngModel)]="value.selected"
            [checked]="value.selected"
            (change)="onSelectItem($event, value.value)"
          />
          <label class="inline-icon" for="filter-{{ i }}-{{ uniqueId }}">
            <span
              capraTooltip
              tooltipContent="{{ value.label }}"
              [tooltipDelay]="[1000, 0]"
              [class.excluded-option]="value.selected && isExclude"
              [class.null-option]="value.value === null || value.value === undefined"
            >
              {{ value.label }}
            </span>
          </label>
        </span>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="filter-desc">
    {{ filterDescription }}
    <div *ngIf="isShowRelevantValuesOnly">Additional values may be hidden due to other applied filters.</div>
  </div>
</div>
